export default __webpack_public_path__ + "static/media/checked.e67fc839.svg";